import { Button } from "@components/Buttons"
import { useIntl } from "@components/Intl"
import { Box } from "@components/Layout"
import React, { Dispatch, FC } from "react"
import { FilterAction } from "./reducer"

type ShowMoreProps = {
  totalHits: number
  hitsLength: number
  dispatch: Dispatch<FilterAction>
}

export const ShowMore: FC<ShowMoreProps> = ({
  totalHits,
  hitsLength,
  dispatch,
}) => {
  const { locale } = useIntl()

  return hitsLength < totalHits ? (
    <Box
      display="flex"
      width="100%"
      justifyContent="center"
      mb={["3rem", "5rem"]}
    >
      <Button
        variant="purple-border"
        maxWidth="13.5rem"
        onClick={() => handleShowMore()}
      >
        {locale === "nl" ? "Toon meer" : "Show more"}
      </Button>
    </Box>
  ) : null

  function handleShowMore() {
    dispatch({ type: "increase-hits-per-page" })
  }
}
